/**
 * The access token lives HERE — in a module variable, in memory.
 *
 * Never localStorage, never sessionStorage: a token readable by JS is a token
 * exfiltratable by XSS, which defeats the entire point of the HttpOnly refresh
 * cookie. A page reload loses it, and that is fine — the boot sequence calls
 * /auth/refresh and gets a new one from the cookie.
 */
let accessToken: string | null = null
const listeners = new Set<() => void>()

export const getAccessToken = () => accessToken

export function setAccessToken(token: string | null) {
  accessToken = token
  listeners.forEach((l) => l())
}

export function clearSession() {
  accessToken = null
  listeners.forEach((l) => l())
}

export function onTokenChange(fn: () => void) {
  listeners.add(fn)
  return () => listeners.delete(fn)
}
